import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Field, reduxForm, reset } from "redux-form";
import { ROOT_URL, APP_URL } from "../helper/Config";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { login, logout, clearMessage, setLocale } from "../actions";
import { register } from "../actions";
import $ from "jquery";
import { history } from "../helper/History";
import ReCAPTCHA from "react-google-recaptcha";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: localStorage.getItem("pendingSharedTestPath") ? 2 : 0,
      roles: [],
      lang: null,

      // ✅ captcha
      recaptchaToken: null,
      recaptchaError: null,
    };

    setTimeout(() => {
      localStorage.removeItem("alert2");
    }, 120000);

    window.scrollTo(0, 0);

    axios
      .get(`${ROOT_URL}/getRoles`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        this.setState({
          roles: response.data.roles,
        });
      })
      .catch((error) => { });

    // PRH SAFE FIX START: Redirect already logged-in FT individual users to pending free test
    this.redirectLoggedInFtIndividualUser();
    // PRH SAFE FIX END

    this.registerUser = this.registerUser.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
  }


  getPendingSharedTestPath() {
    return localStorage.getItem("pendingSharedTestPath") || "";
  }

  getSharedInvitationRegisteredBy(path) {
    if (!path) {
      return "";
    }

    if (path.indexOf("/coaching-tool/") === 0) {
      return "Shared-Coaching";
    }

    if (path.indexOf("/recruitment-link/") === 0) {
      return "Shared-Recruitment";
    }

    return "Shared-Diagnostic";
  }

  // PRH SAFE FIX START: Redirect already logged-in FT individual users to pending free test
  redirectLoggedInFtIndividualUser() {
    const userType = localStorage.getItem("userRole");

    if (userType !== "User") {
      return;
    }

    const path = window.location.pathname;
    const param = path.split("/")[2];

    if (param !== "ft-h" && param !== "ft-t") {
      history.push("/");
      return;
    }

    const userId =
      localStorage.getItem("userId") ||
      localStorage.getItem("userid") ||
      localStorage.getItem("user_id") ||
      localStorage.getItem("id");

    if (!userId) {
      history.push("/");
      return;
    }

    axios
      .get(`${ROOT_URL}/getTests/${userId}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        const remainingTest = parseInt(response.data.tests, 10);

        if (remainingTest > 0) {
          if (param === "ft-h") {
            history.push("/happiness");
            return;
          }

          if (param === "ft-t") {
            history.push("/target");
            return;
          }
        }

        history.push("/");
      })
      .catch((error) => {
        console.log(error);
        history.push("/");
      });
  }
  // PRH SAFE FIX END

  onCaptchaChange(token) {
    this.setState({ recaptchaToken: token, recaptchaError: null });
  }

  onCaptchaExpired() {
    this.setState({
      recaptchaToken: null,
      recaptchaError: "Captcha expired. Please verify again.",
    });
  }

  renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div className="form-group">
      <label>{label}</label>
      <input {...input} placeholder="" type={type} className="form-control" />
      {touched && (error && <small className="text-danger">{error}</small>)}
    </div>
  );

  renderSelectField = ({ input, label, meta: { touched, error }, children }) => (
    <div className="form-group">
      <label>{label}</label>
      <select {...input} value={this.state.userRole} className="form-control" required>
        {children}
      </select>
      {touched && (error && <small className="text-danger">{error}</small>)}
    </div>
  );

  syncNavigationWithUserRole() {
    const userRole = localStorage.getItem("userRole");

    if (userRole === "Hr") {
      localStorage.setItem("navigation", "skills");
    } else if (userRole === "Enterprise") {
      localStorage.setItem("navigation", "enterprise");
    } else if (userRole === "User") {
      localStorage.setItem("navigation", "individual");
    }
  }

  registerUser(values) {
    // ✅ block submit if captcha not verified
    if (!this.state.recaptchaToken) {
      this.setState({ recaptchaError: "Please verify captcha before submit." });
      return;
    }

    $("#register-loader").show();
    this.refs.registerBtn.setAttribute("disabled", "disabled");

    var language = localStorage.getItem("lang");
    var checkConsent = localStorage.getItem("cookieConsent");
    var setupConsentF = localStorage.getItem("cookieSetupF");
    var setupConsentS = localStorage.getItem("cookieSetupS");
    var setupConsentM = localStorage.getItem("cookieSetupM");

    values.language = language;
    values.setupConsentF = setupConsentF;
    values.checkConsent = checkConsent;
    values.setupConsentS = setupConsentS;
    values.setupConsentM = setupConsentM;

    const path = window.location.pathname;
    const param = path.split("/")[2];

    if (param == "ft-h") {
      values.registered_by = "FT-Happiness";
      values.role = 2;
    }
    if (param == "ft-t") {
      values.registered_by = "FT-Target";
      values.role = 2;
    }

    const pendingSharedTestPath = this.getPendingSharedTestPath();

    if (pendingSharedTestPath) {
      values.registered_by = this.getSharedInvitationRegisteredBy(pendingSharedTestPath);
      values.shared_invitation_path = pendingSharedTestPath;
      values.shared_invitation_search = localStorage.getItem("pendingSharedTestSearch") || "";
      values.role = 2;
    }

    // ✅ send captcha token to Laravel
    values.captcha_token = this.state.recaptchaToken;

    this.props.register(values, this.refs.registerBtn, (response) => {
      if (response === "success") {
        this.props.reset("RegisterValidation");

        // reset captcha after success
        this.setState({ recaptchaToken: null, recaptchaError: null });
        this.syncNavigationWithUserRole();

        if (localStorage.getItem("alert2") == 2) {
          localStorage.setItem("guide", "1");
          localStorage.removeItem("alert2");
          this.props.history.push("/individual");
        } else if (localStorage.getItem("alert2") == 1) {
          localStorage.setItem("guide", "2");
          localStorage.removeItem("alert2");
          this.props.history.push("/hr");
        } else if (localStorage.getItem("alert2") == 3) {
          localStorage.setItem("guide", "3");
          localStorage.removeItem("alert2");
          this.props.history.push("/talentcompy");
        } else if (localStorage.getItem("redirectpage") == "Enterprise") {
          localStorage.removeItem("redirectpage");
          this.props.history.push("/login/Enterprise");
        } else if (localStorage.getItem("redirectpage") == "Consultant") {
          localStorage.removeItem("redirectpage");
          this.props.history.push("/login/Consultant");
        } else if (localStorage.getItem("redirectpage") == "Consultant") {
          localStorage.removeItem("redirectpage");
          this.props.history.push("/login/ConBuytest");
        } else {
          this.props.history.push("/login");
        }

        $("#login-form-link").addClass("active");
        $("#register-loader").hide();
      } else {
        $("#loginModal").scrollTop(0);
        $("#register-loader").hide();
        this.refs.registerBtn.removeAttribute("disabled");
      }
    });
  }

  renderRoles(roles) {
    if (localStorage.getItem("lang") !== "en") {
      var prof = "Cabinet Bilan";
      var ent = "Cabinet Reclassement";
      var ind = "Particulier";
    } else {
      var prof = "Skills Assessment Firm";
      var ent = "Outplacement Agency";
      var ind = "Individual";
    }
    const path = window.location.pathname;
    const param = path.split("/")[2];

    if (this.state.roles.length > 0) {
      if (param === "ft-h" || param === "ft-t" || this.getPendingSharedTestPath()) {
        return (
          <>
            <option value={2}>{ind}</option>
          </>
        );
      } else {
        return (
          <>
            <option value={3} className="needsclick">
              {prof}
            </option>
            <option value={4} className="needsclick">
              {ent}
            </option>
            <option value={2} className="needsclick">
              {ind}
            </option>
          </>
        );
      }
    }
  }

  showLogin(e) {
    $("#login-form").delay(100).fadeIn(100);
    $("#register-form").fadeOut(100);
    $("#register-form-link").removeClass("active");
    if (e === "#login-form-link") {
      $(".modal-title").text("LOGIN");
      $(e).addClass("active");
    } else {
      $(e.target).addClass("active");
    }
  }

  changeUserRole(e) {
    if (e.target.value == 2) {
      this.setState({
        userRole: 2,
      });
      $("#hrDetail").hide();
    } else if (e.target.value == 4) {
      $("#hrDetail").show();
      this.setState({
        userRole: 4,
      });
    } else if (e.target.value === null) {
      $("#hrDetail").show();
      this.setState({
        userRole: 3,
      });
    } else {
      $("#hrDetail").show();
      this.setState({
        userRole: 3,
      });
    }
  }

  errorMessage() {
    if (this.props.errorMessage == "The email has already been taken. ") {
      return (
        <div class=" alert alert-danger alert-dismissible fade show " role="alert">
          {this.props.errorMessage}
        </div>
      );
    } else if (
      this.props.errorMessage !== null &&
      this.props.errorMessage !== "" &&
      this.props.errorMessage !== "The email has already been taken."
    ) {
      return (
        <div class="alert alert-danger alert-dismissible fade show " role="alert">
          {this.props.errorMessage}
        </div>
      );
    }

    setTimeout(() => {
      this.props.clearMessage();
    }, 60000);
  }

  errMessage() {
     if (!localStorage.getItem("userRole")  && localStorage.getItem("alert2") === "5") {
      return (
       ''
      );
    } else 
       if (!localStorage.getItem("userRole") && (localStorage.getItem("navigation") === "skills" || localStorage.getItem("navigation") === "enterprise" )) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert" style={{ fontSize: "13px" }}>
          <FormattedHTMLMessage id={localStorage.getItem("navigation") === 'skills' ? "alert12" : "alert13"} />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    }
    else if (localStorage.getItem("alert2") == "1" && localStorage.getItem("userRole")) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert" style={{ fontSize: "13px" }}>
          <FormattedHTMLMessage id={localStorage.getItem("userRole") === 'Hr' ? "alert12" : "alert13"} />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    } else if (localStorage.getItem("alert2") == "2" && localStorage.getItem("userRole") && localStorage.getItem("userRole") !== "Enterprise" ) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert">
          <FormattedHTMLMessage id="alert3" />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">;</span>
          </button>
        </div>
      );
    } else if (localStorage.getItem("alert2") == "3" && (localStorage.getItem("userRole") === "Enterprise"  || localStorage.getItem("userRole") === "Hr")) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert">
           <FormattedHTMLMessage id={localStorage.getItem("userRole") === 'Hr' ? "subscription.credit.success" : "alert4"} />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    } else if (localStorage.getItem("alert2") == "4" && (localStorage.getItem("userRole") === "Enterprise"  || localStorage.getItem("userRole") === "Hr")) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert">
           <FormattedHTMLMessage id={localStorage.getItem("userRole") === 'Hr' ? "alert11" : "subscription.credit.success_std"} />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    } else if (localStorage.getItem("alert8") == "1" &&
  localStorage.getItem("userRole")) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert">
          <FormattedHTMLMessage id="alert8" />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    } else if (localStorage.getItem("alert9") == "1" &&
  localStorage.getItem("userRole")) {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert">
          <FormattedHTMLMessage id={localStorage.getItem("userRole") === 'Hr' ? "alert9" : "alert4"}  />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    } else if (localStorage.getItem("alert11") == "1" && localStorage.getItem("userRole") === "Hr") {
      return (
        <div class="alert alert-success alert-dismissible fade show " role="alert">
          <FormattedHTMLMessage id="alert11" />
          <button
            type="button"
            class="close"
            onClick={(e) => localStorage.removeItem("alert2")}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"></span>
          </button>
        </div>
      );
    } else {
      localStorage.removeItem("alert2");
    }

    setTimeout(() => {
      this.props.clearMessage();
    }, 80000);
  }

  msgMessage() {
    return (
      <div class="alert alert-success alert-dismissible fade show " role="alert">
        <FormattedHTMLMessage id="Link.Message" defaultMessage="Login" />
        <button
          type="button"
          class="close"
          onClick={(e) => localStorage.removeItem("alert2")}
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true"></span>
        </button>
      </div>
    );
  }

  render() {
    const { Roles } = this.props;

    const firstname = <FormattedMessage id="signup.firstname" defaultMessage="First Name" />;
    const lastname = <FormattedMessage id="signup.lastname" defaultMessage="Last Name" />;
    const emailaddress = <FormattedMessage id="signup.email" defaultMessage="Email" />;
    const address = <FormattedMessage id="signup.address" defaultMessage="address" />;
    const password = <FormattedMessage id="signup.password" defaultMessage="Password" />;
    const cpassword = <FormattedMessage id="signup.cpassword" defaultMessage="Confirm Password" />;
    const youare = <FormattedMessage id="signup.youare.hr" defaultMessage="Are you a Skills Assessment Firm / an Outplacement Agency / an Individual?" />;

    // ✅ site key
    const RECAPTCHA_SITE_KEY_NEW = "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";
    const RECAPTCHA_SITE_KEY =
      RECAPTCHA_SITE_KEY_NEW || "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";

    // --- IMPORTANT ---
    // Your component returns different forms based on userRole.
    // We add the SAME captcha block before submit button in each form (role 3/4/2/default).
    // -----------------

    if (this.state.userRole == 3) {
      const phonenoHr = <FormattedHTMLMessage id="signup.phone.hr" defaultMessage="Phone No *" />;
      const company = <FormattedHTMLMessage id="signup.company" defaultMessage="Compay Name *" />;
      const designationHr = <FormattedHTMLMessage id="signup.designation.hr" defaultMessage="Designation *" />;
      const addresss = <FormattedMessage id="signup.addresss" defaultMessage="address" />;

      return (
        <div className="col-md-6 col-sm-12 mx-auto col" style={{ marginTop: "10%" }}>
          <h4 className="modal-title text-center text-uppercase w-100 medium text-grey font-20">
            <FormattedMessage id="head.register" defaultMessage="register" />
          </h4>

          {this.errMessage()}
          {this.errorMessage()}

          <form
            id="register-form"
            onSubmit={this.props.handleSubmit((e) => this.registerUser(e))}
            style={{ display: "block", padding: "15px 26px", border: "1px solid #000" }}
          >
            <Field name="role" component={this.renderSelectField} label={youare} onChange={(e) => this.changeUserRole(e)} required>
              <option defaultValue="">Register as</option>
              {this.renderRoles(Roles)}
            </Field>

            <Field name="firstName" type="text" component={this.renderField} label={firstname} />
            <Field name="lastName" type="text" component={this.renderField} label={lastname} />
            <Field name="email" type="email" component={this.renderField} label={emailaddress} />
            {this.errorMessage()}
            <Field name="address" type="text" component={this.renderField} label={addresss} />
            <Field name="phone" type="tel" component={this.renderField} label={phonenoHr} />

            <div id="hrDetail" style={{ display: "" }}>
              <Field name="companyName" type="text" component={this.renderField} label={company} />
              <Field name="designation" type="text" component={this.renderField} label={designationHr} />
            </div>

            <Field name="password" type="password" component={this.renderField} label={password} />
            <Field name="confirmPass" type="password" component={this.renderField} label={cpassword} />

            {/* ✅ CAPTCHA */}
            <div className="form-group" style={{ marginTop: 10 }}>
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={this.onCaptchaChange}
                onExpired={this.onCaptchaExpired}
              />
              {this.state.recaptchaError ? (
                <small className="text-danger d-block mt-2">{this.state.recaptchaError}</small>
              ) : null}
            </div>

            <div className="form-group">
              <div className="row">
                <FormattedMessage id="signup.mandaory" defaultMessage="* mandatory" />
                <div className="m-auto d-flex">
                  <button
                    type="submit"
                    name="register-submit"
                    id="register-submit"
                    tabIndex="4"
                    className="form-control btn btn-primary mr-3 whitespacenowrap"
                    ref="registerBtn"
                    disabled={!this.state.recaptchaToken}
                  >
                    <FormattedMessage id="signup.signup" defaultMessage="" />
                  </button>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="m-auto d-flex">
                  <FormattedMessage id="siignup.click.desc" defaultMessage="If you already registered click to" />
                  &nbsp;&nbsp;
                  <Link className="" to="/login">
                    <FormattedMessage id="signup.login" defaultMessage="lOG IN" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="float-left">
              <div className="spinner-border text-primary ml-2" role="status" id="register-loader">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </form>
        </div>
      );
    }

    if (this.state.userRole == 4) {
      const phonenoCons = <FormattedHTMLMessage id="signup.phone" defaultMessage="Phone No *" />;
      const companyInd = <FormattedHTMLMessage id="signup.company" defaultMessage="Compay Name *" />;
      const designationInd = <FormattedHTMLMessage id="signup.designation" defaultMessage="Designation *" />;

      return (
        <div className="col-md-6 col-sm-12 mx-auto col" style={{ marginTop: "10%" }}>
          <h4 className="modal-title text-center text-uppercase w-100 medium text-grey font-20">
            <FormattedMessage id="head.register" defaultMessage="register" />
          </h4>

          {this.errMessage()}
          {this.errorMessage()}

          <form
            id="register-form"
            onSubmit={this.props.handleSubmit((e) => this.registerUser(e))}
            style={{ display: "block", padding: "15px 26px", border: "1px solid #000" }}
          >
            <Field name="role" component={this.renderSelectField} label={youare} onChange={(e) => this.changeUserRole(e)} required>
              <option value="">Registered as</option>
              {this.renderRoles(Roles)}
            </Field>

            <Field name="firstName" type="text" component={this.renderField} label={firstname} />
            <Field name="lastName" type="text" component={this.renderField} label={lastname} />
            <Field name="email" type="email" component={this.renderField} label={emailaddress} />
            {this.errorMessage()}
            <Field name="address" type="text" component={this.renderField} label={address} />
            <Field name="phone" type="tel" component={this.renderField} label={phonenoCons} />
            <Field name="companyName" type="text" component={this.renderField} label={companyInd} />
            <Field name="designation" type="text" component={this.renderField} label={designationInd} />
            <Field name="password" type="password" component={this.renderField} label={password} />
            <Field name="confirmPass" type="password" component={this.renderField} label={cpassword} />

            {/* ✅ CAPTCHA */}
            <div className="form-group" style={{ marginTop: 10 }}>
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={this.onCaptchaChange}
                onExpired={this.onCaptchaExpired}
              />
              {this.state.recaptchaError ? (
                <small className="text-danger d-block mt-2">{this.state.recaptchaError}</small>
              ) : null}
            </div>

            <div className="form-group">
              <div className="row">
                <FormattedMessage id="signup.mandaory" defaultMessage="* mandatory" />
                <div className="m-auto d-flex">
                  <button
                    type="submit"
                    name="register-submit"
                    id="register-submit"
                    tabIndex="4"
                    className="form-control btn btn-primary mr-3 whitespacenowrap"
                    ref="registerBtn"
                    disabled={!this.state.recaptchaToken}
                  >
                    <FormattedMessage id="signup.signup" defaultMessage="" />
                  </button>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="m-auto d-flex">
                  <FormattedMessage id="siignup.click.desc" defaultMessage="If you already registered click to" />
                  &nbsp;&nbsp;
                  <Link className="" to="/login">
                    <FormattedMessage id="signup.login" defaultMessage="lOG IN" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="float-left">
              <div className="spinner-border text-primary ml-2" role="status" id="register-loader">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </form>
        </div>
      );
    }

    if (this.state.userRole == 2) {
      const phonenoInd = <FormattedHTMLMessage id="signup.phone" defaultMessage="Phone No *" />;

      return (
        <div className="col-md-6 col-sm-12 mx-auto col" style={{ marginTop: "10%" }}>
          <h4 className="modal-title text-center text-uppercase w-100 medium text-grey font-20">
            <FormattedMessage id="head.register" defaultMessage="register" />
          </h4>

          {localStorage.getItem("Linktest") ? this.msgMessage() : ""}
          {this.errMessage()}
          {this.errorMessage()}

          <form
            id="register-form"
            onSubmit={this.props.handleSubmit((e) => this.registerUser(e))}
            style={{ display: "block", padding: "15px 26px", border: "1px solid #000" }}
          >
            <Field name="role" component={this.renderSelectField} label={youare} onChange={(e) => this.changeUserRole(e)} required>
              <option value="">Registered as</option>
              {this.renderRoles(Roles)}
            </Field>

            <Field name="firstName" type="text" component={this.renderField} label={firstname} role="2" />
            <Field name="lastName" type="text" component={this.renderField} label={lastname} />
            <Field name="email" type="email" component={this.renderField} label={emailaddress} />
            {this.errorMessage()}
            <Field name="phone" type="tel" component={this.renderField} label={phonenoInd} />
            <Field name="password" type="password" component={this.renderField} label={password} />
            <Field name="confirmPass" type="password" component={this.renderField} label={cpassword} />

            <FormattedMessage id="signup.mandaory" defaultMessage="* mandatory" />
            <br />
            <input name="agree" placeholder="" type="checkbox" required></input>
            <span className="ml-3 mb-5" style={{ fontSize: "13px" }}>
              <FormattedHTMLMessage id="signup.consent" defaultMessage="consent" />
            </span>

            {/* ✅ CAPTCHA */}
            <div className="form-group" style={{ marginTop: 10 }}>
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={this.onCaptchaChange}
                onExpired={this.onCaptchaExpired}
              />
              {this.state.recaptchaError ? (
                <small className="text-danger d-block mt-2">{this.state.recaptchaError}</small>
              ) : null}
            </div>

            <div className="form-group">
              <div className="row">
                <div className="m-auto d-flex">
                  <button
                    type="submit"
                    name="register-submit"
                    id="register-submit"
                    tabIndex="4"
                    className="form-control btn btn-primary mr-3 whitespacenowrap"
                    ref="registerBtn"
                    disabled={!this.state.recaptchaToken}
                  >
                    <FormattedMessage id="signup.signup" defaultMessage="" />
                  </button>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="m-auto d-flex">
                  <FormattedMessage id="siignup.click.desc" defaultMessage="If you already registered click to" />
                  &nbsp;&nbsp;
                  <Link className="" to="/login">
                    <FormattedMessage id="signup.login" defaultMessage="lOG IN" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="float-left">
              <div className="spinner-border text-primary ml-2" role="status" id="register-loader">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </form>
        </div>
      );
    }

    // default form (only role dropdown + submit)
    return (
      <div className="col-md-6 col-sm-12 mx-auto col" style={{ marginTop: "10%" }}>
        <h4 className="modal-title text-center text-uppercase w-100 medium text-grey font-20">
          <FormattedMessage id="head.register" defaultMessage="register" />
        </h4>

        {localStorage.getItem("Linktest") ? this.msgMessage() : ""}
        {this.errMessage()}
        {this.errorMessage()}

        <form
          id="register-form"
          onSubmit={this.props.handleSubmit((e) => this.registerUser(e))}
          style={{ display: "block", padding: "15px 26px", border: "1px solid #000" }}
        >
          <Field name="role" component={this.renderSelectField} label={youare} onChange={(e) => this.changeUserRole(e)} required>
            <option value="">Registered as</option>
            {this.renderRoles(Roles)}
          </Field>

          {/* ✅ CAPTCHA */}
          <div className="form-group" style={{ marginTop: 10 }}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={this.onCaptchaChange}
              onExpired={this.onCaptchaExpired}
            />
            {this.state.recaptchaError ? (
              <small className="text-danger d-block mt-2">{this.state.recaptchaError}</small>
            ) : null}
          </div>

          <div className="form-group">
            <div className="row">
              <div className="m-auto d-flex">
                <button
                  type="submit"
                  name="register-submit"
                  id="register-submit"
                  tabIndex="4"
                  className="form-control btn btn-primary mr-3 whitespacenowrap"
                  ref="registerBtn"
                  disabled={!this.state.recaptchaToken}
                >
                  <FormattedMessage id="signup.signup" defaultMessage="" />
                </button>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="m-auto d-flex">
                <FormattedMessage id="siignup.click.desc" defaultMessage="If you already registered click to" />
                &nbsp;&nbsp;
                <Link className="" to="/login">
                  <FormattedMessage id="signup.login" defaultMessage="lOG IN" />
                </Link>
              </div>
            </div>
          </div>

          <div className="float-left">
            <div className="spinner-border text-primary ml-2" role="status" id="register-loader">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.role) {
    errors.role = "Select the register type";
  }
  if (!values.firstName) {
    errors.firstName = "First Name is required";
  }
  if (!values.address) {
    errors.address = "address is required";
  }
  if (!values.lastName) {
    errors.lastName = "Last Name is required";
  }
  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.role) {
    values.role = 3;
  }
  if (values.role == 3) {
    if (!values.phone) errors.phone = "*Field required";
    else if (/^(?:\+\d{11}|\d{10})$/i.test(values.phone) == false) errors.phone = "Invalid phone number";
    if (!values.companyName) errors.companyName = "*Field required";
    if (!values.designation) errors.designation = "*Field required";
  }
  if (values.role == 4) {
    if (!values.phone) errors.phone = "*Field required";
    else if (/^(?:\+\d{11}|\d{10})$/i.test(values.phone) == false) errors.phone = "Invalid phone number";
    if (!values.companyName) errors.companyName = "*Field required";
    if (!values.designation) errors.designation = "*Field required";
  }
  if (!values.password) errors.password = "Password is equired";
  if (!values.confirmPass) errors.confirmPass = "Confirm password is required";
  else if (values.password && values.confirmPass && values.password !== values.confirmPass) {
    errors.confirmPass = "Password miss match";
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    RegisterValidation: state.form.RegisterValidation,
    signupError: state.auth.signupError,
    errorMessage: state.auth.loginError,
  };
};

Register = connect(mapStateToProps, { register, reset, clearMessage })(Register);

export default reduxForm({
  form: "RegisterValidation",
  enableReinitialize: true,
  validate,
})(Register);